import { SectionItem } from '@/features/jobs/info-gathering/components/Section'
import { type PhysicalAddress } from '@/features/jobs/info-gathering/PhysicalAddress'

export interface PhysicalAddressSectionItemsProps {
  address?: PhysicalAddress
}

export function PhysicalAddressSectionItems({
  address,
}: PhysicalAddressSectionItemsProps) {
  return (
    <>
      <SectionItem
        label="Address line 1"
        value={address?.addressLine1}
        isSensitive
      />
      {address?.addressLine2 && (
        <SectionItem
          label="Address line 2"
          value={address.addressLine2}
          isSensitive
        />
      )}
      <SectionItem label="City" value={address?.city} />
      <SectionItem
        label="ZIP / Postal code"
        value={address?.postalCode}
        isSensitive
      />
      <SectionItem label="State" value={address?.region} isSensitive />
      <SectionItem label="Country" value={address?.country} isSensitive />
    </>
  )
}
